export const APPNAME = "ULPGL - Goma"
export const APPOWNER = "Université Libre des Pays des Grands Lacs"
export const APPDNS = "https://ulpgl.ac.cd"
export const APPCREATOR = "Bureau de communication - ULPGL"
export const APPCONTACTS = {
    email: ["rectorat@ulpgl.net", "info@ulpgl.net"],
    phone: ["+243 998 668 267", "+243 977 556 726"],
    address: "Avenue du Lac, N°2 Quartier Himbi II, C. Goma, V. Goma"
}; 